export default __webpack_public_path__ + "static/media/home-travel-agency-trustpilot.8b8fbd48.jpg";